var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _c(
      "div",
      { staticClass: "full-height" },
      [
        _c(
          "el-dialog",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.formLoading,
                expression: "formLoading",
              },
            ],
            attrs: {
              top: "2%",
              title: !_vm.formData.id ? "建立商家" : "商家維護",
              visible: _vm.dialogFormVisible,
              "append-to-body": "",
              "show-close": "",
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogFormVisible = $event
              },
            },
          },
          [
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c("el-card", { staticClass: "box-card" }, [
                      _c(
                        "div",
                        { staticClass: "advertise-data" },
                        [
                          _c(
                            "el-form",
                            {
                              ref: "companyForm",
                              attrs: { model: _vm.formData },
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { "margin-bottom": "30px" },
                                  attrs: { prop: "fileInfo" },
                                },
                                [
                                  _c("Upload", {
                                    ref: "uploadLogoRef",
                                    attrs: {
                                      require: true,
                                      "limit-file-count": 1,
                                      payload: _vm.formData,
                                      accept: ".jpg,.jpeg,.png",
                                      "data-obj": {
                                        id: 43,
                                        type: "companyLogo",
                                      },
                                      "use-drag": false,
                                      action: "file/fileUploadLogo",
                                      "auto-upload": false,
                                      "show-file-list": true,
                                      "form-on-loading-parent": _vm.formLoading,
                                      "btn-txt": "上傳",
                                      "before-file-list":
                                        _vm.formData.fileInfo &&
                                        _vm.formData.fileInfo.length
                                          ? _vm.formData.fileInfo[0].files
                                          : [],
                                      limitText:
                                        "顯示圖片最佳尺寸為500x500大小，圖片須為.jpg,.jpeg,.png格式，限制不超過2000MB",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "公司名稱",
                                    "label-width": _vm.formLabelWidth,
                                    prop: "name",
                                    rules: [
                                      {
                                        required: true,
                                        message: "請輸入公司名稱",
                                        trigger: "blur",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { autocomplete: "off" },
                                    model: {
                                      value: _vm.formData.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "name", $$v)
                                      },
                                      expression: "formData.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "統一編號",
                                    "label-width": _vm.formLabelWidth,
                                    prop: "vatNumber",
                                    rules: [
                                      {
                                        required: true,
                                        message: "請輸入統一編號",
                                        trigger: "blur",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { autocomplete: "off" },
                                    model: {
                                      value: _vm.formData.vatNumber,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "vatNumber", $$v)
                                      },
                                      expression: "formData.vatNumber",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "負責人",
                                    "label-width": _vm.formLabelWidth,
                                    prop: "boss",
                                    rules: [
                                      {
                                        required: true,
                                        message: "請輸入負責人",
                                        trigger: "blur",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { autocomplete: "off" },
                                    model: {
                                      value: _vm.formData.boss,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "boss", $$v)
                                      },
                                      expression: "formData.boss",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "Email",
                                    "label-width": _vm.formLabelWidth,
                                    prop: "email",
                                    rules: [
                                      {
                                        required: false,
                                        pattern: _vm.pattern.email,
                                        message: "Email格式不正確",
                                        trigger: "blur",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { autocomplete: "off" },
                                    model: {
                                      value: _vm.formData.email,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "email", $$v)
                                      },
                                      expression: "formData.email",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "電話",
                                    "label-width": _vm.formLabelWidth,
                                    prop: "tel",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { autocomplete: "off" },
                                    model: {
                                      value: _vm.formData.tel,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "tel", $$v)
                                      },
                                      expression: "formData.tel",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "地址",
                                    "label-width": _vm.formLabelWidth,
                                    prop: "address",
                                    rules: [
                                      {
                                        required: true,
                                        message: "請輸入地址",
                                        trigger: "blur",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { autocomplete: "off" },
                                    model: {
                                      value: _vm.formData.address,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "address", $$v)
                                      },
                                      expression: "formData.address",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "簽約期間",
                                    "label-width": _vm.formLabelWidth,
                                    prop: "signDate",
                                    rules: [
                                      {
                                        required: true,
                                        message: "請輸入簽約期間",
                                        trigger: "blur",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticClass: "w-full-date",
                                    attrs: {
                                      type: "daterange",
                                      "unlink-panels": "",
                                      "range-separator": "至",
                                      "start-placeholder": "開始日期",
                                      "end-placeholder": "結束日期",
                                      "value-format": "yyyy-MM-dd",
                                    },
                                    model: {
                                      value: _vm.formData.signDate,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "signDate", $$v)
                                      },
                                      expression: "formData.signDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "官方網址",
                                    "label-width": _vm.formLabelWidth,
                                    prop: "url",
                                    rules: [
                                      {
                                        required: true,
                                        message: "請輸入官方網址",
                                        trigger: "blur",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { autocomplete: "off" },
                                    model: {
                                      value: _vm.formData.url,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "url", $$v)
                                      },
                                      expression: "formData.url",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { color: "#4b4b4b" },
                    attrs: { type: "warning" },
                    on: {
                      click: function ($event) {
                        return _vm.saveData("companyFormData")
                      },
                    },
                  },
                  [_vm._v("儲 存")]
                ),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        _vm.dialogFormVisible = false
                      },
                    },
                  },
                  [_vm._v(" 取 消 ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              top: "2%",
              "append-to-body": "",
              title: !_vm.adFormData.id ? "新增廣告" : "廣告詳情",
              visible: _vm.dialogAdViewVisible,
              width: "50%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogAdViewVisible = $event
              },
            },
          },
          [
            _c(
              "el-card",
              { staticClass: "box-card" },
              [
                _c(
                  "el-form",
                  {
                    ref: "adForm",
                    attrs: {
                      model: _vm.adFormData,
                      "label-width": _vm.formLabelWidth,
                      "label-position": "right",
                      disabled: _vm.adFormData.status == 3,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "廣告名稱",
                          prop: "name",
                          rules: [
                            {
                              required: true,
                              message: "請輸入廣告名稱",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "廣告名稱" },
                          model: {
                            value: _vm.adFormData.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.adFormData, "name", $$v)
                            },
                            expression: "adFormData.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "廣告副標題",
                          prop: "subTitle",
                          rules: [
                            {
                              required: true,
                              message: "請輸入廣告副標題",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "廣告副標題" },
                          model: {
                            value: _vm.adFormData.subTitle,
                            callback: function ($$v) {
                              _vm.$set(_vm.adFormData, "subTitle", $$v)
                            },
                            expression: "adFormData.subTitle",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "優惠碼", prop: "code" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "優惠碼" },
                          model: {
                            value: _vm.adFormData.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.adFormData, "code", $$v)
                            },
                            expression: "adFormData.code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "廣告描述",
                          prop: "description",
                          rules: [
                            {
                              required: true,
                              message: "請輸入廣告描述",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            autosize: { minRows: 6, maxRows: 8 },
                            type: "textarea",
                            placeholder: "廣告描述",
                          },
                          model: {
                            value: _vm.adFormData.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.adFormData, "description", $$v)
                            },
                            expression: "adFormData.description",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "廣告期間",
                          "label-width": _vm.formLabelWidth,
                          prop: "adDate",
                          rules: [
                            {
                              required: true,
                              message: "請輸入簽約期間",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-date-picker", {
                          staticClass: "w-full-date",
                          attrs: {
                            type: "daterange",
                            "unlink-panels": "",
                            "range-separator": "至",
                            "start-placeholder": "開始日期",
                            "end-placeholder": "結束日期",
                            "value-format": "yyyy-MM-dd",
                          },
                          model: {
                            value: _vm.adFormData.adDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.adFormData, "adDate", $$v)
                            },
                            expression: "adFormData.adDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "狀態" } },
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-text": "啟用",
                            "inactive-text": "停用",
                            "active-color": "#13ce66",
                            "inactive-color": "#ff4949",
                          },
                          model: {
                            value: _vm.adFormData.enable,
                            callback: function ($$v) {
                              _vm.$set(_vm.adFormData, "enable", $$v)
                            },
                            expression: "adFormData.enable",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _vm.adFormData.status != 3
                  ? _c(
                      "el-button",
                      {
                        staticStyle: { color: "#4b4b4b" },
                        attrs: { type: "warning" },
                        on: { click: _vm.handleSaveAdData },
                      },
                      [_vm._v("儲 存")]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    attrs: { type: _vm.adFormData.status == 3 ? "danger" : "" },
                    on: {
                      click: function ($event) {
                        _vm.dialogAdViewVisible = false
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.adFormData.status == 3 ? "關 閉" : "取 消")
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.formLoading,
                expression: "formLoading",
              },
            ],
            attrs: {
              top: "2%",
              title: !_vm.formAdPositionData.id
                ? "建立廣告版位"
                : "廣告版位維護",
              visible: _vm.dialogAdSlotVisible,
              "append-to-body": "",
              "show-close": "",
              width: "60%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogAdSlotVisible = $event
              },
            },
          },
          [
            _c(
              "el-card",
              { staticClass: "box-card" },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c("el-col", { attrs: { span: 24 } }, [
                      _c(
                        "div",
                        { staticClass: "advertise-data" },
                        [
                          _vm.selectedAdRow
                            ? _c(
                                "el-card",
                                {
                                  staticClass: "box-card",
                                  staticStyle: { "margin-bottom": "24px" },
                                },
                                [
                                  _c(
                                    "el-descriptions",
                                    {
                                      attrs: {
                                        title: "",
                                        column: 1,
                                        size: "small",
                                        border: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-descriptions-item",
                                        [
                                          _c("template", { slot: "label" }, [
                                            _vm._v(" 廣告標題 "),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "clipboard",
                                                  rawName: "v-clipboard:copy",
                                                  value: _vm.selectedAdRow.name,
                                                  expression:
                                                    "selectedAdRow.name",
                                                  arg: "copy",
                                                },
                                                {
                                                  name: "clipboard",
                                                  rawName:
                                                    "v-clipboard:success",
                                                  value: _vm.clipboardSuccess,
                                                  expression:
                                                    "clipboardSuccess",
                                                  arg: "success",
                                                },
                                              ],
                                              staticClass: "copy-container",
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.selectedAdRow.name
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        !!_vm.selectedAdRow
                                                          .name,
                                                      expression:
                                                        "!!selectedAdRow.name",
                                                    },
                                                  ],
                                                  staticClass: "copy-icon",
                                                },
                                                [
                                                  _c("el-icon", {
                                                    attrs: {
                                                      name: "document-copy",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                      _c(
                                        "el-descriptions-item",
                                        [
                                          _c("template", { slot: "label" }, [
                                            _vm._v(" 廣告副標題 "),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "clipboard",
                                                  rawName: "v-clipboard:copy",
                                                  value:
                                                    _vm.selectedAdRow.subTitle,
                                                  expression:
                                                    "selectedAdRow.subTitle",
                                                  arg: "copy",
                                                },
                                                {
                                                  name: "clipboard",
                                                  rawName:
                                                    "v-clipboard:success",
                                                  value: _vm.clipboardSuccess,
                                                  expression:
                                                    "clipboardSuccess",
                                                  arg: "success",
                                                },
                                              ],
                                              staticClass: "copy-container",
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.selectedAdRow.subTitle
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        !!_vm.selectedAdRow
                                                          .subTitle,
                                                      expression:
                                                        "!!selectedAdRow.subTitle",
                                                    },
                                                  ],
                                                  staticClass: "copy-icon",
                                                },
                                                [
                                                  _c("el-icon", {
                                                    attrs: {
                                                      name: "document-copy",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                      _c(
                                        "el-descriptions-item",
                                        [
                                          _c("template", { slot: "label" }, [
                                            _vm._v(" 廣告描述 "),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "clipboard",
                                                  rawName: "v-clipboard:copy",
                                                  value:
                                                    _vm.selectedAdRow
                                                      .description,
                                                  expression:
                                                    "selectedAdRow.description",
                                                  arg: "copy",
                                                },
                                                {
                                                  name: "clipboard",
                                                  rawName:
                                                    "v-clipboard:success",
                                                  value: _vm.clipboardSuccess,
                                                  expression:
                                                    "clipboardSuccess",
                                                  arg: "success",
                                                },
                                              ],
                                              staticClass: "copy-container",
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.selectedAdRow
                                                        .description
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        !!_vm.selectedAdRow
                                                          .description,
                                                      expression:
                                                        "!!selectedAdRow.description",
                                                    },
                                                  ],
                                                  staticClass: "copy-icon",
                                                },
                                                [
                                                  _c("el-icon", {
                                                    attrs: {
                                                      name: "document-copy",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                      _c(
                                        "el-descriptions-item",
                                        [
                                          _c("template", { slot: "label" }, [
                                            _vm._v(" 優惠碼 "),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "clipboard",
                                                  rawName: "v-clipboard:copy",
                                                  value: _vm.selectedAdRow.code,
                                                  expression:
                                                    "selectedAdRow.code",
                                                  arg: "copy",
                                                },
                                                {
                                                  name: "clipboard",
                                                  rawName:
                                                    "v-clipboard:success",
                                                  value: _vm.clipboardSuccess,
                                                  expression:
                                                    "clipboardSuccess",
                                                  arg: "success",
                                                },
                                              ],
                                              staticClass: "copy-container",
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.selectedAdRow.code
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        !!_vm.selectedAdRow
                                                          .code,
                                                      expression:
                                                        "!!selectedAdRow.code",
                                                    },
                                                  ],
                                                  staticClass: "copy-icon",
                                                },
                                                [
                                                  _c("el-icon", {
                                                    attrs: {
                                                      name: "document-copy",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                      _c(
                                        "el-descriptions-item",
                                        [
                                          _c("template", { slot: "label" }, [
                                            _vm._v(" 廣告期間 "),
                                          ]),
                                          _c(
                                            "el-tag",
                                            { attrs: { size: "small" } },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.selectedAdRow
                                                      .startDate +
                                                      " 至 " +
                                                      _vm.selectedAdRow.endDate
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                      _c(
                                        "el-descriptions-item",
                                        [
                                          _c("template", { slot: "label" }, [
                                            _vm._v(" 狀態 "),
                                          ]),
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                size: "small",
                                                type:
                                                  _vm.selectedAdRow.status == 1
                                                    ? "warning"
                                                    : _vm.selectedAdRow
                                                        .status == 2
                                                    ? "success"
                                                    : _vm.selectedAdRow
                                                        .status == 3
                                                    ? "info"
                                                    : "danger",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedAdRow.status ==
                                                      1
                                                      ? "未開始"
                                                      : _vm.selectedAdRow
                                                          .status == 2
                                                      ? "進行中"
                                                      : _vm.selectedAdRow
                                                          .status == 3
                                                      ? "已結束"
                                                      : "-"
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form",
                            {
                              ref: "adPositionForm",
                              attrs: {
                                model: _vm.formAdPositionData,
                                disabled: _vm.selectedAdRow.status == 3,
                              },
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "廣告版位",
                                    "label-width": _vm.formLabelWidth,
                                    prop: "slotId",
                                    rules: [
                                      {
                                        required: true,
                                        message: "請選擇廣告版位",
                                        trigger: "blur",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      model: {
                                        value: _vm.formAdPositionData.slotId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formAdPositionData,
                                            "slotId",
                                            $$v
                                          )
                                        },
                                        expression: "formAdPositionData.slotId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.handleFormatSlotOptions(
                                        _vm.selectedAdRow.slot
                                      ),
                                      function (slotItem) {
                                        return _c(
                                          "el-radio-button",
                                          {
                                            key: slotItem.id,
                                            attrs: {
                                              label: slotItem.id,
                                              disabled:
                                                slotItem.disabled ||
                                                !!_vm.formAdPositionData.id,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  slotItem.project +
                                                    " - " +
                                                    slotItem.name
                                                )
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "廣告排序",
                                    "label-width": _vm.formLabelWidth,
                                    prop: "priority",
                                    rules: [
                                      {
                                        required: true,
                                        message: "請輸入廣告排序",
                                        trigger: "blur",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { autocomplete: "off" },
                                    model: {
                                      value: _vm.formAdPositionData.priority,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formAdPositionData,
                                          "priority",
                                          $$v
                                        )
                                      },
                                      expression: "formAdPositionData.priority",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "廣告連結",
                                    "label-width": _vm.formLabelWidth,
                                    prop: "link",
                                    rules: [
                                      {
                                        required: true,
                                        message: "請輸入廣告連結",
                                        trigger: "blur",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { autocomplete: "off" },
                                    model: {
                                      value: _vm.formAdPositionData.link,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formAdPositionData,
                                          "link",
                                          $$v
                                        )
                                      },
                                      expression: "formAdPositionData.link",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { "margin-bottom": "30px" },
                                  attrs: { prop: "fileInfo" },
                                },
                                [
                                  _c("Upload", {
                                    ref: "uploadRef",
                                    attrs: {
                                      require: true,
                                      "limit-file-count": 1,
                                      payload: _vm.formAdPositionData,
                                      accept: ".jpg,.jpeg,.png",
                                      "data-obj": { id: 42, type: "adSlot" },
                                      "use-drag": false,
                                      action: "file/fileUploadAd",
                                      "auto-upload": false,
                                      "show-file-list": true,
                                      "form-on-loading-parent": _vm.formLoading,
                                      "btn-txt": "上傳",
                                      "before-file-list":
                                        _vm.formAdPositionData.fileInfo &&
                                        _vm.formAdPositionData.fileInfo.length
                                          ? _vm.formAdPositionData.fileInfo[0]
                                              .files
                                          : [],
                                      limitText: _vm.formAdPositionData.slotId
                                        ? "顯示圖片最佳尺寸為" +
                                          (_vm.formAdPositionData.slotId == 3
                                            ? "1024x437 (21:9)"
                                            : _vm.formAdPositionData.slotId == 4
                                            ? "500x500（1:1）"
                                            : "1080x605 (16:9)") +
                                          "大小，圖片須為.jpg,.jpeg,.png格式，限制不超過2000MB"
                                        : null,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    false
                      ? _c("el-col", { attrs: { span: 12 } }, [
                          _c(
                            "div",
                            [
                              _c("p", [_vm._v("當前版位列表")]),
                              _c(
                                "el-table",
                                {
                                  attrs: {
                                    data: _vm.selectedAdRow.slot,
                                    border: "",
                                    fit: "",
                                    size: "small",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "版位",
                                      prop: "slotId",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.handleFormatSlotTitle(
                                                      scope.row.slotId
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1869920504
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: { align: "center", label: "封面圖" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.fileInfo
                                                ? _c("el-image", {
                                                    staticStyle: {
                                                      height: "100px",
                                                    },
                                                    attrs: {
                                                      src: scope.row.fileInfo
                                                        .url
                                                        ? scope.row.fileInfo.url
                                                        : "https://fakeimg.pl/300x300/",
                                                      fit: "contain",
                                                      "preview-src-list": [
                                                        scope.row.fileInfo.url,
                                                      ],
                                                      lazy: true,
                                                    },
                                                  })
                                                : _c("el-image", {
                                                    staticStyle: {
                                                      height: "100px",
                                                    },
                                                    attrs: {
                                                      src: "https://fakeimg.pl/300x300/",
                                                      fit: "contain",
                                                      "preview-src-list": [
                                                        "https://fakeimg.pl/300x300/",
                                                      ],
                                                      lazy: true,
                                                    },
                                                  }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2490387629
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      width: "80",
                                      label: "排序",
                                      prop: "priority",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      width: "180",
                                      label: "連結",
                                      prop: "link",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "a",
                                                {
                                                  staticStyle: {
                                                    color: "#1890ff",
                                                  },
                                                  attrs: {
                                                    href: scope.row.link,
                                                    target: "_blank",
                                                  },
                                                },
                                                [_vm._v(_vm._s(scope.row.link))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1479561015
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _vm.selectedAdRow.status != 3
                  ? _c(
                      "el-button",
                      {
                        staticStyle: { color: "#4b4b4b" },
                        attrs: { type: "warning" },
                        on: {
                          click: function ($event) {
                            return _vm.saveData("asPositionFormData")
                          },
                        },
                      },
                      [_vm._v("儲 存")]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: _vm.selectedAdRow.status == 3 ? "danger" : "",
                    },
                    on: {
                      click: function ($event) {
                        _vm.dialogAdSlotVisible = false
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.selectedAdRow.status == 3 ? "關 閉" : "取 消"
                        ) +
                        " "
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-form",
          {
            staticClass: "filter-form",
            attrs: { inline: true },
            nativeOn: {
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "查詢" } },
              [
                _c("el-input", {
                  attrs: { placeholder: "輸入商家/廣告名稱" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.getList($event)
                    },
                  },
                  model: {
                    value: _vm.listQuery.qry,
                    callback: function ($$v) {
                      _vm.$set(_vm.listQuery, "qry", $$v)
                    },
                    expression: "listQuery.qry",
                  },
                }),
              ],
              1
            ),
            _c("el-button", {
              staticStyle: { "margin-top": "8px", "margin-left": "5px" },
              attrs: {
                type: "primary",
                icon: "el-icon-search",
                circle: "",
                disabled: _vm.listLoading,
              },
              on: { click: _vm.getList },
            }),
            _c("el-button", {
              attrs: {
                type: "warning",
                circle: "",
                icon: "el-icon-plus",
                disabled: _vm.listLoading,
              },
              on: {
                click: function ($event) {
                  return _vm.editCompanyData({ id: null })
                },
              },
            }),
            _c("el-button", {
              staticStyle: { cursor: "pointer" },
              attrs: {
                type: "success",
                loading: _vm.listLoading,
                circle: "",
                icon: "el-icon-refresh-left",
              },
              on: {
                click: function ($event) {
                  return _vm.refresh()
                },
              },
            }),
            _c("CompanyList", { staticClass: "company-list" }),
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { position: "relative", height: "80%" } },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                ref: "formDetailsTable",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.list,
                  border: "",
                  fit: "",
                  size: "small",
                  "highlight-current-row": "",
                  height: "100%",
                },
                on: { "sort-change": _vm.sortChange },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "數量",
                    width: "1",
                    type: "expand",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticStyle: { margin: "8px 0" } },
                            [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    size: "small",
                                    border: "",
                                    fit: "",
                                    data: scope.row.advertise,
                                    height: "360",
                                    "row-class-name": _vm.tableRowClassName,
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { align: "center", width: "60" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.$index + 1)
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      prop: "travelName1",
                                      label: "廣告方案",
                                      width: "400",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("div", [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(scope.row.name)
                                                  ),
                                                ]),
                                                _c("br"),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(scope.row.subTitle) +
                                                    " "
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      width: "180",
                                      label: "廣告日期",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.startDate +
                                                      " 至 " +
                                                      scope.row.endDate
                                                  )
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      width: "90",
                                      label: "狀態",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-tag",
                                                {
                                                  attrs: {
                                                    type:
                                                      scope.row.status == 1
                                                        ? "warning"
                                                        : scope.row.status == 2
                                                        ? "success"
                                                        : scope.row.status == 3
                                                        ? "info"
                                                        : "danger",
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.status == 1
                                                          ? "未開始"
                                                          : scope.row.status ==
                                                            2
                                                          ? "進行中"
                                                          : scope.row.status ==
                                                            3
                                                          ? "已結束"
                                                          : "-"
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      width: "270",
                                      label: "編輯版位",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return _vm._l(
                                              scope.row.slot,
                                              function (currentAdSlot) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: currentAdSlot.id,
                                                    staticStyle: {
                                                      padding: "4px 0",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-tag",
                                                      {
                                                        staticStyle: {
                                                          display: "flex",
                                                          "justify-content":
                                                            "space-between",
                                                          "align-items":
                                                            "center",
                                                          cursor: "pointer",
                                                        },
                                                        attrs: {
                                                          size: "small",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.editAdSlotData(
                                                              scope.row.id,
                                                              currentAdSlot
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              display: "flex",
                                                              gap: "0 8px",
                                                              "align-items":
                                                                "center",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("el-image", {
                                                                  staticStyle: {
                                                                    height:
                                                                      "60px",
                                                                    width:
                                                                      "60px",
                                                                    "border-radius":
                                                                      "10px",
                                                                  },
                                                                  attrs: {
                                                                    src: currentAdSlot.fileInfo
                                                                      ? currentAdSlot
                                                                          .fileInfo
                                                                          .url
                                                                      : "https://fakeimg.pl/60/60",
                                                                    fit: "contain",
                                                                    "preview-src-list":
                                                                      [
                                                                        currentAdSlot.fileInfo
                                                                          ? currentAdSlot
                                                                              .fileInfo
                                                                              .url
                                                                          : "https://fakeimg.pl/60/60",
                                                                      ],
                                                                    lazy: true,
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.preventDefault()
                                                                      },
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.handleFormatSlotTitle(
                                                                    currentAdSlot.slotId
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          [
                                                            _c("el-button", {
                                                              attrs: {
                                                                icon: "el-icon-edit",
                                                                circle: "",
                                                                type: "text",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            )
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      width: "140",
                                      label: "新增版位",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                [
                                                  _c("el-button", {
                                                    attrs: {
                                                      size: "mini",
                                                      type: "warning",
                                                      circle: "",
                                                      icon: "el-icon-plus",
                                                      disabled:
                                                        scope.row.status == 3 ||
                                                        (scope.row.slot &&
                                                          scope.row.slot
                                                            .length >= 4),
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.editAdSlotData(
                                                          scope.row.id
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      width: "140",
                                      label: "編輯廣告",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                [
                                                  _c("el-button", {
                                                    attrs: {
                                                      size: "mini",
                                                      type:
                                                        scope.row.status == 3
                                                          ? ""
                                                          : "success",
                                                      circle: "",
                                                      icon:
                                                        scope.row.status == 3
                                                          ? "el-icon-view"
                                                          : "el-icon-edit",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.editAdData(
                                                          scope.row.id,
                                                          false,
                                                          scope.row.status == 3
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "項次", width: "60" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { align: "center", label: "商家 LOGO", width: "100" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          !!scope.row.fileInfo && !!scope.row.fileInfo.url
                            ? _c("img", {
                                staticStyle: {
                                  height: "60px",
                                  width: "60px",
                                  "border-radius": "50%",
                                  border: "1px solid #ddd",
                                  "object-fit": "cover",
                                },
                                attrs: { src: scope.row.fileInfo.url },
                              })
                            : _c("el-image", {
                                staticStyle: {
                                  height: "60px",
                                  width: "60px",
                                  "border-radius": "50%",
                                  border: "1px solid #ddd",
                                },
                                attrs: {
                                  src: "https://fakeimg.pl/300x300/",
                                  fit: "cover",
                                  "preview-src-list": [
                                    "https://fakeimg.pl/300/300",
                                  ],
                                  lazy: true,
                                },
                              }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { label: "商家名稱", width: "480" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                placement: "right",
                                width: "400",
                                trigger: "hover",
                              },
                            },
                            [
                              _c(
                                "el-descriptions",
                                {
                                  staticClass: "margin-top",
                                  attrs: {
                                    title: "商家詳情",
                                    column: 1,
                                    size: "small",
                                    border: "",
                                  },
                                },
                                [
                                  _c(
                                    "el-descriptions-item",
                                    [
                                      _c("template", { slot: "label" }, [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-office-building",
                                        }),
                                        _vm._v(" 商家名稱 "),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:copy",
                                              value: row.name,
                                              expression: "row.name",
                                              arg: "copy",
                                            },
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:success",
                                              value: _vm.clipboardSuccess,
                                              expression: "clipboardSuccess",
                                              arg: "success",
                                            },
                                          ],
                                          staticClass: "copy-container",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              " " + _vm._s(row.name) + " "
                                            ),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !!row.name,
                                                  expression: "!!row.name",
                                                },
                                              ],
                                              staticClass: "copy-icon",
                                            },
                                            [
                                              _c("el-icon", {
                                                attrs: {
                                                  name: "document-copy",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "el-descriptions-item",
                                    [
                                      _c("template", { slot: "label" }, [
                                        _c("i", {
                                          staticClass: "el-icon-tickets",
                                        }),
                                        _vm._v(" 統一編號 "),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:copy",
                                              value: row.vatNumber,
                                              expression: "row.vatNumber",
                                              arg: "copy",
                                            },
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:success",
                                              value: _vm.clipboardSuccess,
                                              expression: "clipboardSuccess",
                                              arg: "success",
                                            },
                                          ],
                                          staticClass: "copy-container",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              " " + _vm._s(row.vatNumber) + " "
                                            ),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !!row.vatNumber,
                                                  expression: "!!row.vatNumber",
                                                },
                                              ],
                                              staticClass: "copy-icon",
                                            },
                                            [
                                              _c("el-icon", {
                                                attrs: {
                                                  name: "document-copy",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "el-descriptions-item",
                                    [
                                      _c("template", { slot: "label" }, [
                                        _c("i", {
                                          staticClass: "el-icon-user",
                                        }),
                                        _vm._v(" 負責人 "),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:copy",
                                              value: row.boss,
                                              expression: "row.boss",
                                              arg: "copy",
                                            },
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:success",
                                              value: _vm.clipboardSuccess,
                                              expression: "clipboardSuccess",
                                              arg: "success",
                                            },
                                          ],
                                          staticClass: "copy-container",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              " " + _vm._s(row.boss) + " "
                                            ),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !!row.boss,
                                                  expression: "!!row.boss",
                                                },
                                              ],
                                              staticClass: "copy-icon",
                                            },
                                            [
                                              _c("el-icon", {
                                                attrs: {
                                                  name: "document-copy",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "el-descriptions-item",
                                    [
                                      _c("template", { slot: "label" }, [
                                        _c("i", {
                                          staticClass: "el-icon-message",
                                        }),
                                        _vm._v(" E-mail "),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:copy",
                                              value: row.email,
                                              expression: "row.email",
                                              arg: "copy",
                                            },
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:success",
                                              value: _vm.clipboardSuccess,
                                              expression: "clipboardSuccess",
                                              arg: "success",
                                            },
                                          ],
                                          staticClass: "copy-container",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              " " + _vm._s(row.email) + " "
                                            ),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !!row.email,
                                                  expression: "!!row.email",
                                                },
                                              ],
                                              staticClass: "copy-icon",
                                            },
                                            [
                                              _c("el-icon", {
                                                attrs: {
                                                  name: "document-copy",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "el-descriptions-item",
                                    [
                                      _c("template", { slot: "label" }, [
                                        _c("i", {
                                          staticClass: "el-icon-mobile-phone",
                                        }),
                                        _vm._v(" 電話 "),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:copy",
                                              value: row.tel,
                                              expression: "row.tel",
                                              arg: "copy",
                                            },
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:success",
                                              value: _vm.clipboardSuccess,
                                              expression: "clipboardSuccess",
                                              arg: "success",
                                            },
                                          ],
                                          staticClass: "copy-container",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(" " + _vm._s(row.tel) + " "),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !!row.tel,
                                                  expression: "!!row.tel",
                                                },
                                              ],
                                              staticClass: "copy-icon",
                                            },
                                            [
                                              _c("el-icon", {
                                                attrs: {
                                                  name: "document-copy",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "el-descriptions-item",
                                    [
                                      _c("template", { slot: "label" }, [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-location-outline",
                                        }),
                                        _vm._v(" 地址 "),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:copy",
                                              value: row.address,
                                              expression: "row.address",
                                              arg: "copy",
                                            },
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:success",
                                              value: _vm.clipboardSuccess,
                                              expression: "clipboardSuccess",
                                              arg: "success",
                                            },
                                          ],
                                          staticClass: "copy-container",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              " " + _vm._s(row.address) + " "
                                            ),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !!row.address,
                                                  expression: "!!row.address",
                                                },
                                              ],
                                              staticClass: "copy-icon",
                                            },
                                            [
                                              _c("el-icon", {
                                                attrs: {
                                                  name: "document-copy",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "el-descriptions-item",
                                    [
                                      _c("template", { slot: "label" }, [
                                        _c("i", {
                                          staticClass: "el-icon-time",
                                        }),
                                        _vm._v(" 簽約日期 "),
                                      ]),
                                      _c(
                                        "el-tag",
                                        { attrs: { size: "small" } },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                row.startDate +
                                                  " 至 " +
                                                  row.endDate
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                  _c(
                                    "el-descriptions-item",
                                    [
                                      _c("template", { slot: "label" }, [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-location-outline",
                                        }),
                                        _vm._v(" 官方網址 "),
                                      ]),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:copy",
                                              value: row.url,
                                              expression: "row.url",
                                              arg: "copy",
                                            },
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:success",
                                              value: _vm.clipboardSuccess,
                                              expression: "clipboardSuccess",
                                              arg: "success",
                                            },
                                          ],
                                          staticClass: "copy-container",
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticStyle: { color: "#1890ff" },
                                              attrs: {
                                                href: row.url,
                                                target: "_blank",
                                              },
                                              on: {
                                                "!click": function ($event) {},
                                              },
                                            },
                                            [_vm._v(_vm._s(row.url))]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: !!row.url,
                                                  expression: "!!row.url",
                                                },
                                              ],
                                              staticClass: "copy-icon",
                                            },
                                            [
                                              _c("el-icon", {
                                                attrs: {
                                                  name: "document-copy",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    hover: "opacity:75%",
                                    width: "fit-content",
                                  },
                                  attrs: { slot: "reference" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleExpand(row)
                                    },
                                  },
                                  slot: "reference",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "text-decoration": "underline",
                                        "font-weight": "500",
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(row.name) + " ")]
                                  ),
                                  _c("br"),
                                  _c(
                                    "span",
                                    { staticStyle: { color: "#939393" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            row.startDate + " 至 " + row.endDate
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: { align: "center", width: "90", label: "簽約狀態" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                size: "small",
                                type: _vm.handleStatus(
                                  scope.row.startDate,
                                  scope.row.endDate
                                ).type,
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.handleStatus(
                                        scope.row.startDate,
                                        scope.row.endDate
                                      ).text
                                    )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c(
                  "el-table-column",
                  { attrs: { label: "廣告數量" } },
                  [
                    _c("el-table-column", {
                      attrs: { align: "center", label: "未開始", width: "90" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "15px",
                                    "font-weight": "bold",
                                    cursor: "pointer",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleExpand(scope.row)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "strong",
                                    { staticStyle: { color: "#ffba00" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.handleCount(
                                            scope.row.advertise,
                                            1
                                          )
                                        ) + " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { align: "center", label: "進行中", width: "90" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "15px",
                                    "font-weight": "bold",
                                    cursor: "pointer",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleExpand(scope.row)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "strong",
                                    { staticStyle: { color: "#42b983" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.handleCount(
                                              scope.row.advertise,
                                              2
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { align: "center", label: "已結束", width: "90" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "15px",
                                    "font-weight": "bold",
                                    cursor: "pointer",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleExpand(scope.row)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "strong",
                                    { staticStyle: { color: "gray" } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.handleCount(
                                              scope.row.advertise,
                                              3
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    label: "操作",
                    width: "280",
                    prop: "satisfactionAnalysis",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "success" },
                              on: {
                                click: function ($event) {
                                  return _vm.editCompanyData(scope.row)
                                },
                              },
                            },
                            [_vm._v("編輯")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.exportPdf },
                            },
                            [_vm._v("匯出資料")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "warning" },
                              on: {
                                click: function ($event) {
                                  return _vm.editAdData(scope.row.id)
                                },
                              },
                            },
                            [_vm._v("新增廣告")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("pagination", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.total > 0,
              expression: "total > 0",
            },
          ],
          attrs: {
            layout: "prev, pager, next",
            total: _vm.total,
            page: _vm.listQuery.page,
            limit: _vm.listQuery.limit,
          },
          on: {
            "update:page": function ($event) {
              return _vm.$set(_vm.listQuery, "page", $event)
            },
            "update:limit": function ($event) {
              return _vm.$set(_vm.listQuery, "limit", $event)
            },
            pagination: _vm.getList,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }